/*
 * @Description: 小红书合同信息
 * @Author: 杨志航
 * @Date: 2026-05-27 09:11:34
 */
import React from 'react'
import { Form, Input, InputNumber, Select, Table, Row, Col } from 'antd'

const { Option } = Select
const FormItem = Form.Item

const invoiceList = [
  { id: 1, name: "专票" },
  { id: 2, name: "普票" },
]

const expenseList = [
  { id: 1, name: "策划服务费" },
  { id: 2, name: "设计服务费" },
  { id: 3, name: "咨询服务费" },
  { id: 4, name: "信息服务费" },
  { id: 5, name: "推广服务费" },
  { id: 6, name: "其他现代服务" }
]

const RedBook = (props) => {
  const { 
    form, 
    oaidObj, 
    accountObj, 
    contractData, 
    detail, 
    dataRedSource 
  } = props
  
  const { getFieldDecorator } = form

  const redColumns = [
    {
      title: " ",
      dataIndex: "partyType",
      key: "partyType",
      width: "10%",
    }, {
      title: <><span style={{ color: "red" }}>*</span>负责人</>,
      dataIndex: "contactPerson",
      key: "contactPerson",
      align: 'center',
      render: (_, record) => (
        <FormItem style={{ margin: 0 }}>
          {getFieldDecorator(`contactPerson_${record.key}`, {
            rules: [{ required: true, message: '请输入负责人' }]
          })(<Input placeholder="请输入" />)}
        </FormItem>
      ),
    }, {
      title: <><span style={{ color: "red" }}>*</span>联系电话</>,
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      align: 'center',
      render: (_, record) => (
        <FormItem style={{ margin: 0 }}>
          {getFieldDecorator(`phoneNumber_${record.key}`, {
            rules: [{ required: true, message: '请输入联系电话' }]
          })(<Input placeholder="请输入" />)}
        </FormItem>
      ),
    }, {
      title: <><span style={{ color: "red" }}>*</span>授权邮箱</>,
      dataIndex: "emailAddress",
      key: "emailAddress",
      align: 'center',
      render: (_, record) => (
        <FormItem style={{ margin: 0 }}>
          {getFieldDecorator(`emailAddress_${record.key}`, {
            rules: [{ required: true, message: '请输入授权邮箱' }]
          })(<Input placeholder="请输入" />)}
        </FormItem>
      ),
    }, {
      title: <><span style={{ color: "red" }}>*</span>授权邮箱后缀</>,
      dataIndex: "emailSuffix",
      key: "emailSuffix",
      align: 'center',
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: 5 }}>@</span>
          <FormItem style={{ margin: 0 }}>
            {getFieldDecorator(`emailSuffix_${record.key}`, {
              rules: [{ required: true, message: '请输入授权邮箱后缀' }]
            })(<Input placeholder="请输入" />)}
          </FormItem>
        </div>
      ),
    }
  ]

  return (
    <div className="red-book-info-module">
      <div className="line"></div>
      <h3 className="apply-tit">双方公司信息及联系方式</h3>
      <div className="underline"></div>
      
      {/* 甲乙双方基本信息 */}
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="甲方" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{oaidObj.name ? oaidObj.name : detail.partA}</div>
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="乙方" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.fullName ? accountObj.fullName : detail.partB}</div>
          </FormItem>
        </Col>
      </Row>

      {/* 地址 */}
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="地址" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Aaddress', {
              rules: [{ required: true, message: '请输入甲方联系地址' }]
            })(<Input placeholder="请输入甲方联系地址" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="地址" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.address || accountObj.address == '' ? accountObj.address : JSON.stringify(contractData) != '{}' ? contractData.partB.address : ''}</div>
          </FormItem>
        </Col>
      </Row>

      {/* 联系人 */}
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="联系人" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Acontacts', {
              rules: [{ required: true, message: '请输入甲方联系人姓名' }]
            })(<Input placeholder="请输入甲方联系人姓名" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="联系人" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Bcontacts', {
              rules: [{ required: true, message: '请输入乙方联系人姓名' }]
            })(<Input placeholder="请输入乙方联系人姓名" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>

      {/* 电话 */}
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Atel', {
              rules: [{ required: true, message: '请输入甲方联系电话' }]
            })(<Input placeholder="请输入甲方联系电话" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Btel', {
              rules: [{ required: true, message: '请输入乙方联系电话' }]
            })(<Input placeholder="请输入乙方联系电话" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>

      {/* 邮箱 */}
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="邮箱" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Aemail', {
              rules: [{ required: true, message: '请输入甲方电子邮箱' }]
            })(<Input placeholder="请输入甲方电子邮箱" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="邮箱" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Bemail', {
              rules: [{ required: true, message: '请输入乙方电子邮箱' }]
            })(<Input placeholder="请输入乙方电子邮箱" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>

      {/* 乙方银行信息 */}
      <Row gutter={24}>
        <Col span={12}></Col>
        <Col span={12}>
          <FormItem label="开户行" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.bankName || accountObj.bankName == '' ? accountObj.bankName : JSON.stringify(contractData) != '{}' ? contractData.partB.bank : ''}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}></Col>
        <Col span={12}>
          <FormItem label="账号" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.bankNo || accountObj.bankNo == '' ? accountObj.bankNo : JSON.stringify(contractData) != '{}' ? contractData.partB.account : ''}</div>
          </FormItem>
        </Col>
      </Row>

      {/* 服务内容 */}
      <div className="line"></div>
      <h3 className="apply-tit">服务内容</h3>
      <div className="underline" style={{ marginBottom: '16px' }}></div>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="媒体" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('mediaName', {
              rules: [{ required: true, message: '请输入媒体名称' }]
            })(<Input placeholder="请输入媒体名称" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="服务费用总金额(含税)" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
            {getFieldDecorator('totalServiceFeeInclusiveTax', {
              rules: [{ required: true, message: '请输入数值' }]
            })(<InputNumber placeholder="请输入数值" precision={2} style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>
      
      <Table
        dataSource={dataRedSource}
        columns={redColumns}
        pagination={false}
        bordered
        size="small"
      />

      {/* 甲方开票信息 */}
      <h3 className="apply-tit" style={{ marginTop: '40px' }}>甲方开票信息</h3>
      <div className="underline" style={{ marginBottom: '16px' }}></div>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="公司名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('companyName', {
              rules: [{ required: true, message: '请输入甲方公司名称' }]
            })(<Input placeholder="请输入甲方公司名称" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="发票类型" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('invoiceType', {
              rules: [{ required: true, message: '请选择发票类型' }]
            })(<Select
              showSearch
              optionFilterProp="children"
              placeholder="请选择发票类型"
              style={{ width: 240 }}
              dropdownMatchSelectWidth={false}
            >
              {
                invoiceList.map((v, i) => {
                  return <Option value={v.name} key={i}>{v.name}</Option>
                })
              }
            </Select>)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="税号" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('taxNumber', {
              rules: [{ required: true, message: '请输入甲方税号' }]
            })(<Input placeholder="请输入甲方税号" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="开票科目" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('expenseItem', {
              rules: [{ required: true, message: '请选择开票科目' }]
            })(<Select
              showSearch
              optionFilterProp="children"
              placeholder="请选择开票科目"
              style={{ width: 240 }}
              dropdownMatchSelectWidth={false}
            >
              {
                expenseList.map((v, i) => {
                  return <Option value={v.name} key={i}>{v.name}</Option>
                })
              }
            </Select>)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="地址" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('address', {
              rules: [{ required: true, message: '请输入甲方联系地址' }]
            })(<Input placeholder="请输入甲方联系地址" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('phone', {
              rules: [{ required: true, message: '请输入甲方联系电话' }]
            })(<Input placeholder="请输入甲方联系电话" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="开户行" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('bankAccount', {
              rules: [{ required: true, message: '请输入甲方开户行' }]
            })(<Input placeholder="请输入甲方开户行" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="银行账号" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('bank', {
              rules: [{ required: true, message: '请输入甲方银行账号' }]
            })(<Input placeholder="请输入甲方银行账号" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>
    </div>
  )
}

export default RedBook